// ----- Account Module -----
export const ACCOUNT_LOGIN = "accountTokenLogin"
export const ACCOUNT_INFO = "accountInfo"
export const ACCOUNT_LOGOUT = "accountLogout"

// ----- Ui Module -----
export const HIDE_SIDE_BAR = "hideSideBar"
export const SHOW_SIDE_BAR = "showSideBar"